import {
  useAppKit,
  useAppKitAccount,
  useDisconnect,
} from "@reown/appkit/react";
import { useState, useEffect } from "react";
import styles from "./WalletConnect.module.css";

export default function ConnectButton({ verifyToken, setStatus, token }) {
  const { open } = useAppKit();
  const { disconnect } = useDisconnect();
  // caipAddress looks like "eip155:8453:0x..." or "solana:5eyk...:<addr>".
  // The first segment is the chain namespace we forward to the backend.
  const { address, isConnected, caipAddress } = useAppKitAccount();
  const [isConnecting, setIsConnecting] = useState(false);

  const handleButtonClick = async () => {
    if (isConnected && address) {
      disconnect();
      setStatus(""); // Clear status when disconnecting
    } else if (!isConnecting) {
      setStatus("Connecting...");
      setIsConnecting(true);
      try {
        await open();
      } catch (error) {
        console.error("Error opening modal:", error);
      } finally {
        setIsConnecting(false);
      }
    }
  };

  useEffect(() => {
    if (address && token) {
      const namespace = caipAddress ? caipAddress.split(":")[0] : "eip155";
      console.log("Connected address:", address, "namespace:", namespace);
      verifyToken(address, token, namespace);
    }
  }, [address, caipAddress, token, verifyToken]);

  return (
    <div>
      <button className={styles.button} onClick={handleButtonClick}>
        {address ? "Disconnect" : "Connect Wallet"}
      </button>
    </div>
  );
}
